// eslint-disable-next-line no-control-regex
export const cleanString = (input) => (input || '').replace(/[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]/g, '').trim()

export const noSpace = (str) => (str || '').replace(/\s/g, '')

export const isStringValid = (input) => {
  const pattern = new RegExp('^[^|<>]*$')
  return pattern.test(input)
}
